import { LogoImgAttraction } from '../../../Files/LogoImgAttraction.js';
import { GetBkgLogo } from '../Functions/GetBkgLogo.js';
import { BlockLink } from '../Blocks/BlockLink.js';
import { BlockStatus } from '../Blocks/BlockStatus.js';

export const BlockLogoAttraction = (props) => {
    const item = props.item;
    const label = props.label;
    const bkg = GetBkgLogo(item.aroute);
    const src = LogoImgAttraction('icon', item.cslug, item.aslug);
    let values = [];
    switch (label) {
        case 'origin':
        case 'family':
            if (label === 'origin') {
                values = [
                    { status: item.status, name: item.aname, route: item.aroute },
                    { name: item.cname, href: `/categorie/${item.cslug}` },
                    { name: item.pname, href: item.proute },
                ];
            }
            if (label === 'family') {
                values = [
                    { status: item.status, name: item.aname, route: item.aroute },
                    { name: item.pname, href: `/categorie/${item.fslug}` },
                    { name: item.oname, href: item.oroute },
                ];
            }
            return (
                <div className={`logo ${bkg}`}>
                    <BlockStatus status={values[0].status} bkg={bkg} />
                    <a className="icon" href={values[0].route} alt={values[0].name} title={values[0].name}>
                        <img className="img" src={src} title={values[0].name} alt={values[0].name} loading="lazy" />
                    </a>
                    <div className="legend">
                        <div className="title">{values[0].name}</div>
                        <BlockLink label="link-true" href={values[1].href} name={values[1].name} />
                        <BlockLink label="link-true" href={values[2].href} name={values[2].name} />
                    </div>
                </div>
            )
        case 'attraction':
            values = [
                { name: item.aname },
                { href: `/categorie/${item.cslug}`, name: item.cname },
                { href: `/origine/${item.oslug}`, name: item.oname },
            ];
            return (
                <div className={`logo ${bkg}`}>
                    <div className="icon">
                        <img className="img" src={src} title={values[0].name} alt={values[0].name} loading="lazy" />
                    </div>
                    <div className="legend">
                        <div className="title">{values[0].name}</div>
                        <BlockLink label="link-true" href={values[1].href} name={values[1].name} />
                        <BlockLink label="link-true" href={values[2].href} name={values[2].name} />
                    </div>
                </div>
            )
        default:
            return (
                <></>
            )
    }
}